/**
 * Sales Sort for eBay™ Advanced Search — eBay sold-listings sorter
 *
 * Its single web-accessible-resource entry exposes the `assets/img/` glob to
 * `<all_urls>` with no `use_dynamic_url`, so every bundled image is fetchable from any
 * page at a fixed URL. The vendor icon `assets/img/icon128.png` is served only when the
 * extension is installed.
 *
 * Being images, the signals load through `probeImage` with no CORS grant, so they
 * survive a restrictive page CSP.
 *
 * Manifest verified against version 1.1.0.
 */

import { probeImage } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'cigjjnkjdjhhncooaedjbkiojgelfocc';

export const salesSortEbay: ExtensionDefinition = {
  id: ID,
  name: 'Sales Sort for eBay™ Advanced Search',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 5_000,
  notes:
    'Exposes the assets/img/ glob to every origin with no dynamic URL. The icon and ' +
    'preview images are conclusive and load without a CORS grant.',
  signals: [
    {
      id: 'war-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/icon128.png via <img> — the extension icon, exposed to every ' +
        'origin and readable without a CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'assets/img/icon128.png'),
    },
    {
      id: 'war-preview-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/preview.png via <img> — a distinctive bundled image, ' +
        'corroborating the identification.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/img/preview.png'),
    },
    {
      id: 'war-home-png',
      kind: 'web-accessible-resource',
      description:
        'Load assets/img/home.png via <img> — a third exposed image, independent of ' +
        'the other paths.',
      weight: 0.5,
      run: () => probeImage(ID, 'assets/img/home.png'),
    },
  ],
};
